import { useState } from 'react';

export default function useLanguage() {
  const getLanguage = () => {
    const languageString = localStorage.getItem('language');
    const _language = JSON.parse(languageString);
    return _language
  };

  const [language, setLanguage] = useState(getLanguage());

  const saveLanguage = __language => {
    localStorage.setItem('language', JSON.stringify(__language));
    setLanguage(__language);
  };

  return {
    setLanguage: saveLanguage,
    language
  }
}